import { HandoverHistoryTypeEnum } from '../../enum/handover-history-type.enum';

/* Copyright CADS
 *
 * All rights are reserved. Reproduction or transmission in whole or in part, in
 * any form or by any means, electronic, mechanical or otherwise, is prohibited
 * without the prior written consent of the copyright owner.
 *
 * THIS FILE IS AUTO GENERATED DO NOT EDIT IT MANULLY
 *
 */

export class HandoverHistoryWebAppData {
  ContractId: string;
  Id: string;
  SiteId: string;
  Reference: string;
  Scaffolds: string[];
  Comments: string;
  When: string;
  CustomerId: string;
  Staff: string;
  Type: HandoverHistoryTypeEnum;
  ScaffoldDiaryId: string;
}


